/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Remove_Audio_File_LabelInputs */



/**
* | output |
* | --- |
* | "Remove custom audio file" |
*
* @param {Audio_Description_Export_Remove_Audio_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_remove_audio_file_label = /** @type {((inputs?: Audio_Description_Export_Remove_Audio_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Remove_Audio_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le fichier audio personnalisé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerdefinierte Audiodatei entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi file audio personalizzato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить пользовательский аудиофайл")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar archivo de audio personalizado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除自定义音频文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カスタムオーディオファイルを削除する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कस्टम ऑडियो फ़ाइल हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover arquivo de áudio personalizado")
	return /** @type {LocalizedString} */ ("Remove custom audio file")
});